angular.module('MW.InsDashboard.GoogleAnalyticsErrorService', [
    'MW.Framework.TranslationService'
])
.factory('GoogleAnalyticsErrorService', [
    'translationService',
    'HOST',
    function (translationService, HOST) {
        'use strict';
        var googleAnalyticsErrorService = {};

        googleAnalyticsErrorService.getError = function (isNoAuthError, isNoUrlError) {
            var anchor, message;

            if (isNoAuthError) {
                anchor = 'https://' + HOST + '/integration';
                message = translationService.getLocalizedString('google-analytics-widget__not-authenticated-error--message');
            } else if (isNoUrlError) {
                anchor = '';
                message = translationService.getLocalizedString('google-analytics-widget__no-selected-property--message');
            } else {
                anchor = '';
                message = '';
            }

            return {
                message: message,
                anchor: anchor
            };
        };

        return googleAnalyticsErrorService;
    }
]);